import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MediumModal from "../../../../components/modals/MediumModal";
import {
  closeLabOrderGeneralResultModal,
  openLabOrderDirectResultModal,
  openLabOrderFileResultModal,
  openLabOrderLinkResultModal,
} from "../../../../redux/actions/modals";

const LabOrderSendResultComponent = (props) => {
  const {
    general_lab_result_order_open,
    general_result_lab_order,
  } = useSelector((state) => state.modals);
  const dispatch = useDispatch();
  return (
    <>
      <MediumModal
        header="لطفا یکی از روش‌های زیر را انتخاب کنید"
        show={general_lab_result_order_open}
        closeFunction={closeLabOrderGeneralResultModal}
      >
        <div>
          <button
            className="btn btn-small btn-outline-success btn-block"
            onClick={() => {
                dispatch(closeLabOrderGeneralResultModal());
                dispatch(openLabOrderFileResultModal(general_result_lab_order));
            }}
          >
            بارگذاری فایل نتیجه آزمایش
          </button>
          <button
            className="btn btn-small btn-outline-success btn-block"
            onClick={() => {
              dispatch(closeLabOrderGeneralResultModal());
              dispatch(openLabOrderLinkResultModal(general_result_lab_order));
            }}
          >
            ارسال لینک مشاهده نتیجه آزمایش
          </button>
          <button
            className="btn btn-small btn-outline-success btn-block"
            onClick={() => {
              dispatch(closeLabOrderGeneralResultModal());
              dispatch(openLabOrderDirectResultModal(general_result_lab_order));
            }}
          >
            نتیجه مستقیما به کاربر ارسال شد
          </button>
        </div>
      </MediumModal>
    </>
  );
};
export default LabOrderSendResultComponent;
